// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__4K4Pk","productName":"Table_productName__2pfkN"};